export enum OnboardingStep {
  START = 1,
  PERSON = 3,
  BUSINESS = 4,
  DOCUMENTS = 5,
  PERFIL = 6,
  PROJECT = 7,
  FINISHED = 8,
}

export const onboardingRedirect: Record<OnboardingStep, string> = {
  [OnboardingStep.START]: '/onboarding',
  [OnboardingStep.PERSON]: '/cadastrar-pessoa',
  [OnboardingStep.BUSINESS]: '/cadastrar-pessoa',
  [OnboardingStep.DOCUMENTS]: '/cadastrar-pessoa',
  [OnboardingStep.PERFIL]: '/cadastrar-pessoa',
  [OnboardingStep.PROJECT]: '/cadastrar-projeto',
  [OnboardingStep.FINISHED]: '/dashboard',
};

export function resolveOnboardingRedirect(
  step?: number
): string | null {
  if (!step) return null;

  const typedStep = step as OnboardingStep;
  return onboardingRedirect[typedStep] ?? '/onboarding';
}
